import React from 'react';
import { Switch, Route } from 'react-router-dom'
import PrivateRoute from "./components/PrivateRoute";
import Navbar from './layout/Navbar'
import Splash from './layout/Splash'
import About from './layout/About'
import Add from './layout/Add'
import How from './layout/How'
import Master from './layout/MasterRecord'
import Detail from './layout/DetailRecord'
import Footer from './layout/Footer'
import Success from './layout/Success'
// import Map from './watershed/Map'
import Map from './components/Map'
import MapView from './views/MapView'

import Lower from './watershed/Lower'
import Middle from './watershed/Middle'
import Upper from './watershed/Upper'


function App() {
  return (
    <div className="app">
      <div className="navbar">
        <Navbar />
      </div>
    <div className="routes">
        <Switch>
        <PrivateRoute path='/add' component={Add} />
        <Route path='/' exact component={Splash} />
        <Route path='/about' exact component={About} />
        <Route path='/info' exact component={How} />
        <Route path='/detail/master' exact component={Master} />
        <Route path='/show/:id' exact component={Detail} />
        <Route path='/success' exact component={Success} />
        <Route path='/map' exact component={Map} />
        <Route path='/map/view' exact component={MapView} />
        <Route path='/watershed/lower' exact component={Lower} />
        <Route path='/watershed/middle' exact component={Middle} />
        <Route path='/watershed/upper' exact component={Upper} />

        </Switch>
    </div>
    <Footer />
</div>

  );
}

export default App;
